export default __webpack_public_path__ + "static/media/Leggings of Bedlam.c747f6c7.jpg";